export const RBOX_LOGGING_LEVEL_PARAM = 'taboola-debug';

export const RBOX_LOGGING_LEVELS = {
    HIDE: -1,
    ERROR: 0,
    WARN: 1,
    INFO: 2,
    DEBUG: 3,
};
